iScreenWizard.controller('FeedbackRapporttypeSelectorController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, userService, WizardFeedbackRapporttype, nieuwe360FeedbackService) {

    $scope.userService = userService;
    $scope.wizardfeedbackrapporttypes = [];

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        nieuwe360FeedbackService.model = {};
        WizardFeedbackRapporttype.all().then(function (wizardfeedbackrapporttypes) {
            $scope.wizardfeedbackrapporttypes = wizardfeedbackrapporttypes;
        });
    };

    $scope.selecteerFeedbackRapporttype = function(wizardfeedbackrapporttype) {
        nieuwe360FeedbackService.model.wizardfeedbackrapporttype = wizardfeedbackrapporttype;
        nieuwe360FeedbackService.SaveState();
        $state.go('360-feedback/feedback-overzicht');
    };

});